import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../../models/utilities/list-header";
import { PageData } from "../../../models/utilities/paged-request";
import { ApiEndpoints, GlobalConstants } from "../../../utils/app-constants";

export class UserSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.USER_USERS;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('ID', ''),
            new ListColumn('Name', 'name', true),
            new ListColumn('Email', 'email', true),
            new ListColumn('Number of Roles', '')
        ];

        // Create our Filter Groups
        const byEmail = this.buildEmail();
        const byName = this.buildName();
        
        this.filters.push(
            byName, byEmail
        );

    }

    // #region Group Builders

    private buildEmail() {
        const byEmailAddress = new FilterGroup('Email', 'text', 'email');
        const opt1 = new FilterBarInputOpt('Email', '');
        
        byEmailAddress.opts = [opt1];

        return byEmailAddress;
    }

    private buildName() {
        const byName = new FilterGroup('Name', 'text', 'name');
        const opt1 = new FilterBarInputOpt('Name', '');
        
        byName.opts = [opt1];

        return byName;
    }
    
    // #endregion

}
